













import { sendUrl } from '@/api/login'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'PaySuccess'
})
export default class PaySuccess extends Vue {
  private count = 5 // 倒计时
  private timer = 0 // 定时器

  // 打开后台系统订单列表页面
  openOrderHtml () {
    const loading = this.$loading({
      lock: true,
      text: '跳转中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    sendUrl()
      .then(res => {
        loading.close()
        if (res.success) {
          const { uuId, webSite } = res.data
          // window.open(`https://yanshi.zowoyoo.com/cm/gtpw_set.jsp?uuId=${uuId}&pathCode=1`)
          // this.$md5() 和 this.$secretKey()  在全局 plugins 中
          const sign = new this.$md5().update(uuId + this.$secretKey()).digest('hex')
          window.open(`${webSite}/cm/gtpw_set.jsp?uuId=${uuId}&sign=${sign}&pathCode=1`)
        }
      }).catch(() => {
        loading.close()
      })
  }

  mounted (): void {
    this.timer = setInterval(() => {
      this.count--
      if (this.count === 0) {
        clearInterval(this.timer)
        this.openOrderHtml()
        console.log('支付已完成跳转至订单列表页完成')
      }
    }, 1000)
  }

  beforeDestroy () {
    clearInterval(this.timer)
  }
}
